import React from 'react';
import { User } from '../../models/UserModel';
import BaseTable, { Column } from '../Base/BaseTable';
import { formatDateTimeCL } from '../../utils/dateTimeChile';

type Props = {
  data: User[];
  loading?: boolean;
  onEdit?: (user: User) => void;
  onDelete?: (id: number) => void;
};

const UsersTable: React.FC<Props> = ({ data, loading, onEdit, onDelete }) => {
  const columns: Column<User>[] = [
    {
      field: 'id',
      header: 'ID',
      width: '80px',
    },
    {
      field: 'username',
      header: 'Usuario',
    },
    {
      field: 'email',
      header: 'Correo',
    },
    {
      field: 'first_name',
      header: 'Nombre',
      render: (row) => row.first_name || '—',
    },
    {
      field: 'last_name',
      header: 'Apellido',
      render: (row) => row.last_name || '—',
    },
    {
      field: 'is_active',
      header: 'Estado',
      render: (row) => (
        <span
          className={`badge ${
            row.is_active ? 'badge-active' : 'badge-inactive'
          }`}
        >
          {row.is_active ? 'Activo' : 'Inactivo'}
        </span>
      ),
    },
    // {
    //   field: 'last_password_updated_at',
    //   header: 'last_password_updated_at',
    //   width: '170px',
    //   render: (row) => formatDateTimeCL(row.last_password_updated_at),
    // },
    // {
    //   field: 'last_sign_in_at',
    //   header: 'last_sign_in_at',
    //   width: '170px',
    //   render: (row) => formatDateTimeCL(row.last_sign_in_at),
    // },
    // {
    //   field: 'last_logout_at',
    //   header: 'last_logout_at',
    //   width: '170px',
    //   render: (row) => formatDateTimeCL(row.last_logout_at),
    // },
  ];

  return (
    <BaseTable<User>
      columns={columns}
      data={data}
      loading={loading}
      onEdit={onEdit}
      onDelete={onDelete ? (id) => onDelete(Number(id)) : undefined}
      emptyMessage="No hay usuarios registrados"
      showActions={true}
    />
  );
};

export default UsersTable;
